import { toCurrency } from '../../utils/formatting';
import Widget from '../Widget';

interface ICurrentBalanceProps extends React.PropsWithChildren {
  currentBalance?: number | string;
}

const CurrentBalance = ({ currentBalance: _currentBalance, children }: ICurrentBalanceProps) => {
  const currentBalance = _currentBalance ?? 0;
  const balanceNum = typeof currentBalance === 'string' ? parseFloat(currentBalance) : currentBalance;
  const formattedBalance = toCurrency(balanceNum);

  return (
    <Widget>
      <div className="p-5.25 flex flex-row items-center justify-between gap-4">
        <div className="text-lg font-semibold">Current balance</div>
        <div className="flex flex-row items-center gap-2">
          <div className="text-xl font-semibold">{formattedBalance}</div>
          {children}
        </div>
      </div>
    </Widget>
  );
};

export default CurrentBalance;
